import { Grid, Paper, Typography } from '@mui/material';

export const Panel = ({ title, quantity, icon }: any) => {
  return (
    <Grid item>
      <Paper
        variant="outlined"
        sx={{
          py: 2,
          textAlign: 'center',
          width: 156,
          height: 140,
          color: '#9E9E9E',
          ':hover': {
            backgroundColor: '#FBB45F',
            color: '#FFFFFF',
          },
        }}
      >
        {icon}
        <Typography fontWeight={400} fontSize={24} color="inherit">
          {quantity}
        </Typography>
        <Typography fontWeight={400} fontSize={12} color="inherit">
          {title}
        </Typography>
      </Paper>
    </Grid>
  );
};
